import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';

import moment from 'moment-timezone';
import { BsPersonVideo } from 'react-icons/bs';
import { languages, getSelectedLanguage } from '../languages';
import Loader from '../components/Loader';
 
class ListaProcessos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            processos: [],
            process_filter: 'all',
            selectedLanguage: getSelectedLanguage()
        }
        this.videoRef = React.createRef();

        // this.videoRef=null;
    }
    componentDidMount() {
        this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
        window.addEventListener('fiscal_language_change', this.languageListener);
        this.get_processos();
        this.logs_timeout = setTimeout(() => {
            this.salvar_log();
        }, 60000);
    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
        if (this.languageListener) {
            window.removeEventListener('fiscal_language_change', this.languageListener);
        }
    }

    async get_processos() {
        this.setState({ loading_screen: true });
        fetch(`${URL}api/fiscal/get_processos/`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_processos();
                    }, 5000);
                }
                else {
                    this.setState({ loading_screen: false, processos: resp.processos });

                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_processos();
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_processos();
                }, 5000);
            });
    }


    salvar_log() {
        fetch(`${URL}api/fiscal/salvar_log?screen=lista`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, 60000);
                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }










    render() {
        let t = languages[this.state.selectedLanguage] || languages.Pt;
        let now = moment();
        let processos_ativos = this.state.processos.filter((item) => now.isSameOrAfter(moment(item.inicio)) && now.isSameOrBefore(moment(item.fim))).length;
        let processos_agendados = this.state.processos.filter((item) => now.isBefore(moment(item.inicio))).length;
        let processos_encerrados = this.state.processos.filter((item) => now.isAfter(moment(item.fim))).length;
        let processos_filtrados = this.state.processos.filter((item) => {
            let inicio = moment(item.inicio);
            let fim = moment(item.fim);
            if (this.state.process_filter == 'active') return now.isSameOrAfter(inicio) && now.isSameOrBefore(fim);
            if (this.state.process_filter == 'scheduled') return now.isBefore(inicio);
            if (this.state.process_filter == 'closed') return now.isAfter(fim);
            return true;
        });
        return (
            <div className="row fiscal-process-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}


                <div className="col-12">
                    <div className="card fiscal-process-card">
                        <div className="card-body">
                            <nav className="fiscal-breadcrumb" aria-label="breadcrumb">
                                <Link to="/">{t.breadcrumb_home}</Link>
                                <i className="mdi mdi-chevron-right"></i>
                                <span>{this.props.faculdade.name}</span>
                                <i className="mdi mdi-chevron-right"></i>
                                <strong>{t.breadcrumb_processes}</strong>
                            </nav>
                            <div className="d-flex justify-content-between fiscal-process-head">
                                <div>
                                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>
                                        {t.fiscal_panel}
                                    </h4>
                                    <p style={{ fontSize: '1rem', color: 'black' }}>{t.fiscal_name}: {this.props.user.name}</p>
                                </div>
                                <div>
                                    <Link to="/treinamentos">
                                        <span className="btn fiscal-message-btn fiscal-message-primary" data-toggle="tooltip">
                                            {t.training_list} <BsPersonVideo/>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            {/* <hr />
                            <div className="row">

                                <div className="col-12 ">
                                    <div className="form-group row">

                                        <div className="col-12 col-md-12" style={{ objectFit: 'contain' }}>


                                            <div style={{ height: '200px' }}>


                                                <div className="project-item" style={{ marginBottom: 0 }}>
                                                    <div className="overlay-container"
                                                        style={{ height: '200px', display: 'flex', justifyContent: 'center' }}>
                                                        {this.props.faculdade.logo != null && <img src={this.props.faculdade.logo} alt="img"
                                                            style={{ height: '200px', objectFit: 'contain', borderRadius: '10px' }} />}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>



                            </div> */}
                            <hr />
                            <div className="fiscal-process-section-head">
                                <div>
                                    <span>{t.exam_processes}</span>
                                    <h4 className="mt-0 header-title fiscal-table-title" style={{ fontSize: '1.5rem', color: 'black' }}>{t.select_supervision}</h4>
                                    <p className="fiscal-table-subtitle" style={{ fontSize: '1rem', color: 'black' }}>{t.linked_processes_subtitle}</p>
                                </div>
                                <strong>{this.state.processos.length} {this.state.processos.length == 1 ? t.process_singular : t.process_plural}</strong>
                            </div>

                            <div className="fiscal-process-filters">
                                <button type="button" onClick={() => this.setState({process_filter:'all'})} className={this.state.process_filter == 'all' ? 'active' : ''}><i className="mdi mdi-view-list-outline"></i> {t.filter_all} <strong>{this.state.processos.length}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'active'})} className={this.state.process_filter == 'active' ? 'active' : ''}><i className="mdi mdi-radiobox-marked"></i> {t.filter_active} <strong>{processos_ativos}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'scheduled'})} className={this.state.process_filter == 'scheduled' ? 'active' : ''}><i className="mdi mdi-calendar-clock"></i> {t.filter_scheduled} <strong>{processos_agendados}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'closed'})} className={this.state.process_filter == 'closed' ? 'active' : ''}><i className="mdi mdi-check-circle-outline"></i> {t.filter_closed} <strong>{processos_encerrados}</strong></button>
                            </div>

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>

                                <div className="fiscal-process-list">
                                    {processos_filtrados.map((item, id) => {
                                        let inicio = moment(item.inicio);
                                        let fim = moment(item.fim);
                                        let status = now.isBefore(inicio) ? t.status_not_started : (now.isAfter(fim) ? t.status_closed : t.status_active);
                                        let statusClass = now.isBefore(inicio) ? 'scheduled' : (now.isAfter(fim) ? 'closed' : 'active');
                                        return (
                                            <Link key={id} to={'/sala/' + item.id} className="fiscal-process-item">
                                                <div className={'fiscal-process-status ' + statusClass}>
                                                    <span></span>{status}
                                                </div>
                                                <div className="fiscal-process-main">
                                                    <div className="fiscal-process-icon">
                                                        <i className="mdi mdi-clipboard-check-outline"></i>
                                                    </div>
                                                    <div>
                                                        <h5>{item.name}</h5>
                                                        <p>{t.process_card_subtitle}</p>
                                                    </div>
                                                </div>
                                                <div className="fiscal-process-dates">
                                                    <div>
                                                        <small>{t.process_start}</small>
                                                        <strong>{inicio.format('DD/MM/YYYY')}</strong>
                                                        <span>{inicio.format('HH:mm')}</span>
                                                    </div>
                                                    <div>
                                                        <small>{t.process_end}</small>
                                                        <strong>{fim.format('DD/MM/YYYY')}</strong>
                                                        <span>{fim.format('HH:mm')}</span>
                                                    </div>
                                                </div>
                                                <div className="fiscal-process-access">
                                                    <span>{t.access}</span>
                                                    <i className="mdi mdi-arrow-right"></i>
                                                </div>
                                            </Link>
                                        )
                                    })}
                                </div>
                                {this.state.processos.length == 0 && <div className="fiscal-process-empty">
                                    <i className="mdi mdi-clipboard-alert-outline"></i>
                                    <p>{t.no_linked_process}</p>
                                </div>}
                                {this.state.processos.length > 0 && processos_filtrados.length == 0 && <div className="fiscal-process-empty">
                                    <i className="mdi mdi-filter-remove-outline"></i>
                                    <p>{t.no_process_found_status.replace('{status}', this.state.process_filter == 'active' ? t.status_active : (this.state.process_filter == 'scheduled' ? t.status_not_started : t.status_closed))}</p>
                                </div>}
                                {/* <div className="row">
                                    <div className="col-12 d-flex justify-content-end">
                                        <ReactPaginate
                                            previousLabel={'Anterior'}
                                            nextLabel={'Próxima'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.total_pages}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick.bind(this)}
                                            containerClassName={'pagination'}
                                            subContainerClassName={'pages pagination'}
                                            activeClassName={'active'}
                                            initialPage={this.state.page - 1}
                                        />
                                    </div>
                                </div> */}



                                {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                            </div>}

                            {this.state.loading_screen == true && <Loader title={this.getTexts().loading_data} description={this.getTexts().loading_environment} />}



                        </div>
                    </div>
                </div>

            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser, logout })(ListaProcessos);
